// extracted by mini-css-extract-plugin
module.exports = {"defaultIconButton":"style_defaultIconButton__KVnyE","copyValue":"style_copyValue__-vupL"};